import React, { useState } from "react";
import { Button, Select } from "semantic-ui-react";
import { BasicModal, PermissionGate } from "../../../components/Shared";
import {
  ListInstitutionalDocument,
  InstitutionalDocumentForm,
} from "../../../components/Admin/InstitutionalDocument";
import "./InstitutionalDocument.scss";

export function InstitutionalDocument() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  // Generate Year Options
  const currentYear = new Date().getFullYear();
  const yearOptions = [{ key: "all", text: "Selecciona un año", value: null }];
  for (let i = currentYear - 9; i <= currentYear + 1; i++) {
    yearOptions.push({
      key: i,
      text: `${i}`,
      value: `${i}`,
    });
  }

  return (
    <>
      <div className="institutional-documents-page">
        <div className="institutional-documents-page__header">
          <div className="institutional-documents-page__filters">
            <Select
              className="edunova-select"
              placeholder="Selecciona un año"
              clearable
              options={yearOptions}
              onChange={(e, { value }) => setSelectedYear(value)}
              value={selectedYear}
            />
          </div>

          <PermissionGate module="institutionalDocument" action="create">
            <Button
              primary
              className="institutional-documents-page__add"
              onClick={onOpenCloseModal}
            >
              Nuevo documento
            </Button>
          </PermissionGate>
        </div>
        <div className="institutional-documents-page__list">
          <ListInstitutionalDocument
            reload={reload}
            onReload={onReload}
            year={selectedYear}
          />
        </div>
      </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear documento institucional"
      >
        <InstitutionalDocumentForm
          onClose={onOpenCloseModal}
          onReload={onReload}
        />
      </BasicModal>
    </>
  );
}
